import { render } from "./devsettingView.vue?vue&type=template&id=1158a380&scoped=true"
import script from "./devsettingView.vue?vue&type=script&lang=js"
export * from "./devsettingView.vue?vue&type=script&lang=js"

import "./devsettingView.vue?vue&type=style&index=0&id=1158a380&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1158a380"]])

export default __exports__